/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  loading: 0,
  families: {
    map: {},
    list: [],
  },
  cities: [],
  zones: [],
  salers: [],
};

export const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setAppLoadingOn: (state) => {
      state.loading += 1;
    },
    setAppLoadingOff: (state) => {
      state.loading -= 1;
    },
    setAppFamilies: (state, action) => {
      state.families.list = action.payload;
      state.families.map = action.payload.reduce((acc, family) => {
        acc[family.id] = family;
        return acc;
      }, {});
    },
    setAppBrands: (state, action) => {
      state.brands = action.payload;
    },
    setCitiesZones: (state, action) => {
      state.cities = (action.payload || []).map((c) => c.city).unique();
      state.zones = (action.payload || []).map((c) => c.zone).unique();
    },
    setExpeditions: (state, action) => {
      state.expeditions = action.payload;
    },
    setPaymentModes: (state, action) => {
      state.paymentModes = action.payload;
    },
    setSalers: (state, action) => {
      state.salers = action.payload;
    },
  },
});

export const {
  setAppLoadingOn, setAppLoadingOff, setAppFamilies, setSalers,
  setAppBrands, setCitiesZones, setExpeditions, setPaymentModes,
} = appSlice.actions;

export default appSlice.reducer;
